const actions = {
    GET_BRANDS: 'GET_BRANDS',
    GET_MODELS: 'GET_MODELS',
    GET_YEAR: 'GET_YEAR',
    DATA_BRANDS: 'DATA_BRANDS',
    DATA_MODELS: 'DATA_MODELS',
    DATA_YEAR: 'DATA_YEAR',
    getBrands: () => ({
        type: actions.GET_BRANDS
    }),
    dataBrands: payload => ({
        type: actions.DATA_BRANDS,
        payload
    }),
    getModels: payload => ({
        type: actions.GET_MODELS,
        payload
    }),
    dataModels: payload => ({
        type: actions.DATA_MODELS,
        payload
    }),
    getYears: payload => ({
        type: actions.GET_YEAR,
        payload
    }),
    dataYears: payload => ({
        type: actions.DATA_YEAR,
        payload
    }),
};
export default actions;
  


// WEBPACK FOOTER //
// ./src/redux/gocar/actions.js